export default {
  title:        'Outros direitos',
  description:  'Autorização para terceiro',
  instructions: 'Para que a pessoa escolhida por você possa exercer o direito de titular frente a Simplic ela deve acessar o link abaixo e fazer algumas validações antes de realizar algum pedido.',
};
